module.exports = __webpack_public_path__ + "static/media/configurar.34f18531.svg";